import { BFormCheckbox } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormCheckbox when migrating. */
export const EgBFormCheckbox = createEgBootstrapProxy(
  "EgBFormCheckbox",
  BFormCheckbox
);
